import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import * as actions from '../action';

function ApplyDiscountModal({
  originalAmount,
  discount,
  amount,
  applyDiscount,
  id,
  showTransaction,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [inputDiscount, setInputDiscount] = useState(0);

  useEffect(() => {
    setInputDiscount(discount);

    return () => {
      setInputDiscount(0);
    };
  }, [discount]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const regex = /^(\d*\.\d{0,2}?|^\d+)$/; // Regular expression to match numbers with up to two decimal places

    if (regex.test(inputValue) || inputValue === '') {
      setInputDiscount(inputValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  const handleSubmit = () => {
    applyDiscount(id, { amount: inputDiscount }, () => {
      showTransaction(id);
      setModal({ isOpen: false });
    });
  };

  const handleRemoveDiscount = () => {
    applyDiscount(id, { amount: 0 }, () => {
      showTransaction(id);
      setModal({ isOpen: false });
    });
  };

  const isInvalid = () => {
    if (!Number(originalAmount)) {
      return Number(inputDiscount) > Number(amount);
    }
    return Number(inputDiscount) > Number(originalAmount);
  };

  return (
    <Modal.Body>
      <div className="d-flex flex-column">
        <div className="form-group">
          <label htmlFor="inputDiscount">Discount Amount</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon3">
                ₱
              </span>
            </div>
            <input
              type="number"
              step="0.01"
              className="form-control"
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              value={inputDiscount}
              id="inputDiscount"
            />
          </div>

          {isInvalid() ? (
            <small className="text-danger form-text">
              Discount cannot be higher than the Amount.
            </small>
          ) : null}
        </div>

        <table className="m-3">
          <tbody>
            <tr>
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Amount</small>
              </td>
              <td>&nbsp;</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {!Number(originalAmount)
                  ? Number(amount).toFixed(2)
                  : Number(originalAmount).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Discount</small>
              </td>
              <td>-</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {Number(inputDiscount).toFixed(2)}
              </td>
            </tr>
            <tr className="border-top">
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Discounted Amount</small>
              </td>
              <td>&nbsp;</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {!Number(originalAmount)
                  ? (Number(amount) - Number(inputDiscount)).toFixed(2)
                  : (Number(originalAmount) - Number(inputDiscount)).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex align-items-stretch justify-content-between mt-5">
          {Acl(permissions, ['CEDULA CORPORATION REMOVE DISCOUNT']) ? (
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={handleRemoveDiscount}
              disabled={!Number(discount) || Number(discount) <= 0}
            >
              Remove Discount
            </button>
          ) : (
            <div />
          )}

          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              className="btn btn-light mr-3"
              onClick={() => setModal({ isOpen: false })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={
                !Number(inputDiscount) || (Number(inputDiscount) && isInvalid())
              }
              onClick={handleSubmit}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ApplyDiscountModal.propTypes = {
  originalAmount: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  applyDiscount: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ApplyDiscountModal);
